import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Provider } from 'react-redux'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
// import logo from '../../static/logo.svg';
import Sidebar from './Sidebar'
import NewProject from './NewProject'

import {
  validateToken,
  invalidateUser
 } from '../actions/'

import {
  is_logged_on,
  is_validating
} from "../helpers"

// import Home from './Home'
import Login from './Login'
import Project from './Project'
import Projects from './Projects'
import Archives from './Archives'
import ProjectArchives from './ProjectArchives'
import Entries from './Entries'
import Users from './Users'
import UserNew from './UserNew'
import Accounts from './Accounts'
import AccountNew from './AccountNew'
import Preferences from './Preferences'

const mapStateToProps = (state) => {
  return {
    auth: state.auth
  }
};

const mapDispatchToProps = dispatch => {
  return {
    validateToken: () => dispatch(validateToken()),
    invalidateUser: () => dispatch(invalidateUser())
  };
};

class ConnectedRoot extends React.Component {
  constructor () {
    super()
    this.state = {
      tokenInvalid: false,
      sidebarCollapsed: false
    }
  }

  componentWillMount() {
    let userdata = JSON.parse( localStorage.getItem('userdata') ) || false

    if ( userdata === false || userdata === undefined || userdata === null ) {
      this.props.invalidateUser()
    } else {
      this.props.validateToken()
    }
  }

  componentDidUpdate(prevProps, prevState) {

    const {tokenInvalid} = this.props.auth
    const prevTokenInvalid = prevProps.auth.tokenInvalid

    if ( tokenInvalid !== prevTokenInvalid ) {
      if ( tokenInvalid   ) {
        this.setState({tokenInvalid: true})
        window.M.toast({html: "The session has expired. Log in to continue."})
      } else {
        this.setState({tokenInvalid: false})
      }
    }
  }

  collapseSidebar() {
    this.setState({ sidebarCollapsed: true })
  }

  expandSidebar() {
    this.setState({ sidebarCollapsed: false })
  }

  render () {

    let mainComp;
    let loggedOn
    if ( !is_validating() && !is_logged_on() ) {
      mainComp = Login;
      loggedOn = false
    } else {
      mainComp = Projects;
      loggedOn = true
    }

    const masterClass = ( this.state.sidebarCollapsed === true ) ? "App collapsed" : "App"
    const collapsed = this.state.sidebarCollapsed

    return (
      <Provider store={this.props.store}>
        <div className={ masterClass }>
          <Router>
            <div className="row">
              <Sidebar loggedOn={loggedOn} collapsed={ collapsed } collapse={this.collapseSidebar.bind(this)} expand={this.expandSidebar.bind(this)}/>
              <div className="col s12 l9 xl10 the-content">
                <div className="content">

                    <div>
                      <Switch>
                        <Route exact path="/" component={mainComp} />
                        <Route exact path="/projects" component={Projects} />
                        <Route exact path="/projects/archive" component={Archives} />
                        <Route exact path="/projects/new" component={NewProject} />
                        <Route exact path="/projects/:id/archive" component={ProjectArchives} />
                        <Route exact path="/projects/:id" component={Project} />
                        <Route path="/feeds/:id/entries" render={props => <Entries {...props} collapsed={ collapsed }/>} />
                        <Route exact path="/login" component={Login} />
                        <Route exact path="/users/new" component={UserNew} />
                        <Route exact path="/users" component={Users} />
                        <Route exact path="/accounts/new" component={AccountNew} />
                        <Route exact path="/accounts" component={Accounts} />
                        <Route exact path="/preferences" component={Preferences} />

                      </Switch>
                    </div>

                </div>
              </div>
            </div>
          </Router>

        </div>
      </Provider>
    )
  }
}

ConnectedRoot.propTypes = {
  store: PropTypes.object.isRequired
}

const Root = connect(mapStateToProps, mapDispatchToProps)(ConnectedRoot);
export default Root



// WEBPACK FOOTER //
// ./src/js/components/Root.js